<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="mode === 'create'">{{"USER_MODE_CREATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'update'">{{"USER_MODE_UPDATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'read'">{{"USER_MODE_READ" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">

    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>


    <mat-horizontal-stepper [linear]="true" #stepper *ngIf="!readOnly">
      <mat-step [stepControl]="userForm">

        <form [formGroup]="userForm" *ngIf="userForm">
          <ng-template matStepLabel>{{'INFORMATION' | translate}}</ng-template>
          <mat-form-field>
            <input matInput [placeholder]="'LASTNAME' | translate" formControlName="lastname" required>
            <mat-error *ngIf="lastname.invalid">{{getErrorMessageLastName()}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input matInput [placeholder]="'FIRSTNAME' | translate" formControlName="firstname" required>
            <mat-error *ngIf="firstname.invalid">{{getErrorMessageFirstName()}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input matInput [placeholder]="'PHONE' | translate" formControlName="phone">
            <mat-hint>{{'VALUE_USER_PHONE_NOT_INTERNATIONAL' | translate}}</mat-hint>
            <mat-error *ngIf="phone.invalid">{{getErrorMessagePhone()}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input matInput [placeholder]="'EMAIL' | translate" formControlName="email" required>
            <mat-error *ngIf="email.invalid">{{getErrorMessageEmail()}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-select formControlName="lang" [placeholder]="'LANG' | translate" required>
              <mat-option value="fr">fr</mat-option>
              <mat-option value="en">en</mat-option>
              <mat-option value="jp">jp</mat-option>
            </mat-select>
            <mat-error *ngIf="lang.invalid">{{getErrorMessageLang()}}</mat-error>
          </mat-form-field>


          <mat-form-field *ngIf="mode === 'update' && currentUserCanChangeUserLevel()">
            <mat-select formControlName="level" [value]="statesService.stateLevel"
                        [placeholder]="'LEVEL' | translate">
              <mat-option *ngFor="let level of levelsList" [value]="level.id">
                {{level.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <mat-slide-toggle formControlName="active" [(ngModel)]="userForm.value.active" [disabled]="toggleDisabled">
            {{userForm.value.active ? ('ACTIVE' | translate) : ('INACTIVE' | translate)}}
          </mat-slide-toggle>

          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="userRoleForm">
        <form [formGroup]="userRoleForm" *ngIf="userRoleForm">
          <ng-template matStepLabel>{{'ROLES'|translate}}</ng-template>


          <mat-selection-list #roles formControlName="roles">
            <mat-list-option *ngFor="let role of typesOfRoles" [selected]="role.selected"
                             (click)="updateRolesIsUser(roles)" [value]="role.value">
              {{role.value|translate}}
            </mat-list-option>


          </mat-selection-list>
          <br clear="left"/>
          <mat-error *ngIf="userRoleForm.invalid">{{getErrorMessageRoles()}}</mat-error>

          <div>
            <button class="btn btn-info" mat-button matStepperPrevious
                    [innerHTML]="'BACK_BUTTON' | translate">Back
            </button>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>

      </mat-step>

      <mat-step [stepControl]="userPassWord" *ngIf="mode ==='create'">
        <form [formGroup]="userPassWord" *ngIf="userPassWord">
          <ng-template matStepLabel>{{'PASSWORD'|translate}}</ng-template>
          <br/>


          <mat-form-field>
            <input matInput [placeholder]="'PASSWORD' | translate" formControlName="plainPassword" type="password">
            <mat-error *ngIf="plainPassword.invalid">{{getErrorMessagePlainPassword()}}</mat-error>
          </mat-form-field>


          <div>
            <button class="btn btn-info" mat-button matStepperPrevious
                    [innerHTML]="'BACK_BUTTON' | translate">Back
            </button>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>

      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>

        <div *ngIf="userForm && userRoleForm">
          <div><b [innerHtml]="'INFORMATION' | translate">Information</b></div>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="'LASTNAME' | translate" [value]="userForm.value.lastname"
                   [readonly]="true">

          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput [placeholder]="'FIRSTNAME' | translate" [value]="userForm.value.firstname"
                   [readonly]="true">

          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput [placeholder]="'PHONE' | translate" [value]="userForm.value.phone"
                   [readonly]="true">

          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput [placeholder]="'EMAIL' | translate" [value]="userForm.value.email"
                   [readonly]="true">

          </mat-form-field>

          <mat-form-field class="readonly">
            <mat-select [value]="userForm.value.lang" [placeholder]="'LANG' | translate" [disabled]="true">
              <mat-option value="fr">fr</mat-option>
              <mat-option value="en">en</mat-option>
              <mat-option value="jp">jp</mat-option>
            </mat-select>
          </mat-form-field>


          <mat-slide-toggle [(ngModel)]="userForm.value.active" [disabled]="true"> {{userForm.value.active ?
            ('ACTIVE' | translate) : ('INACTIVE' | translate)}}
          </mat-slide-toggle>


          <div><b [innerHtml]="'ROLES' | translate">Roles</b></div>


          <mat-chip-list>
            <mat-chip *ngFor="let role of user.roles">{{getRoleDisplayed(role)}}</mat-chip>
          </mat-chip-list>
        </div>

        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
            Back
          </button>
          <button type="button" class="btn btn-warning" (click)="persistUser()">
            <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
            {{'SAVE'|translate}}
          </button>


        </div>
      </mat-step>

    </mat-horizontal-stepper>


    <div *ngIf="readOnly">


      <div><b [innerHtml]="'INFORMATION' | translate">Information</b></div>
      <mat-form-field class="readonly">
        <input matInput [placeholder]="'LASTNAME' | translate" [value]="userForm.value.lastname"
               [readonly]="true">

      </mat-form-field>

      <mat-form-field class="readonly">
        <input matInput [placeholder]="'FIRSTNAME' | translate" [value]="userForm.value.firstname"
               [readonly]="true">

      </mat-form-field>

      <mat-form-field class="readonly">
        <input matInput [placeholder]="'PHONE' | translate" [value]="userForm.value.phone" [readonly]="true">

      </mat-form-field>

      <mat-form-field class="readonly">
        <input matInput [placeholder]="'EMAIL' | translate" [value]="userForm.value.email" [readonly]="true">

      </mat-form-field>

      <mat-form-field class="readonly">
        <mat-select [value]="userForm.value.lang" [placeholder]="'LANG' | translate" [disabled]="true">
          <mat-option value="fr">fr</mat-option>
          <mat-option value="en">en</mat-option>
          <mat-option value="jp">jp</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle [(ngModel)]="userForm.value.active" [disabled]="true"> {{userForm.value.active ? ('ACTIVE'
        | translate) : ('INACTIVE' | translate)}}
      </mat-slide-toggle>

      <div><b [innerHtml]="'ROLES' | translate">Roles</b></div>

      <mat-chip-list>
        <mat-chip *ngFor="let role of user.roles">{{getRoleDisplayed(role)}}</mat-chip>
      </mat-chip-list>


    </div>


  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="closeModal()" [innerHTML]="'CLOSE' | translate">Close
    </button>
  </div>
</ng-template>


<button *ngIf="mode ==='read'" type="button" class="btn list-tools" (click)="openModal(content)" placement="left"
        [ngbTooltip]="'READ_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEye"></fa-icon>
</button>

<button *ngIf="mode ==='create'" type="button" class="btn top-list-tools" (click)="openModal(content)" placement="left"
        [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faPlus"></fa-icon>
  {{'ADD_USER'|translate}}
</button>


<button *ngIf="mode ==='update'" type="button" class="btn list-tools" (click)="openModal(content)" placement="left"
        [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEdit"></fa-icon>
</button>
